import { render, staticRenderFns } from "./BlogCoverPreview.vue?vue&type=template&id=53e31e22&scoped=true&"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogCoverPreview.vue?vue&type=style&index=0&id=53e31e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e31e22",
  null
  
)

export default component.exports